import React from "react";
import { DragDropContext, } from "react-beautiful-dnd";
import { Grid, Button } from '@mui/material';
import DroppableCard from "./Components/DroppableCard";
import TextList from "./Components/TextList";
import './dragtoimage.css'

const defaultTheme = {
  answerSpot: {
    borderRadius: "4px",
    height: "100%",
    width: "100%",
    backgroundColor: "#00ADEF",
  },
  root: {
    padding: "10px",
    borderRadius: '5px',
  },
  choiceSpot: {
  },
  textCard: {
    margin: ".2rem",
    flex: 1,
    left: 'auto !important',
    top: 'auto !important'
  },
  cardRoot: {
    margin: ".5rem",
    width: '95%',

  },
  listOnDrag: {
    backgroundColor: "rgb(255 115 115 / 20%)",
  },
  dropCard: {
    marginTop: "5px",
    marginRight: "4px",
    display: "flex",
    flex: 1,
  },
  dropSite: {
    padding: ".5rem",
  },
  dropSiteGrid: {
    height: "100%",
  },
  choiceSite: {
    padding: ".5rem",
    minHeight: "100%",
  },
  heading: {
    marginBottom: "5px",
    marginLeft: "5px",
  },
  choices: {
    background: "rgba(0,0,0,0)",
  },
  feedBackText: {
    color: "black",
  },
  correctCard: {
    backgroundColor: "#109746",
    border: '2px solid #109746',
    margin: ".5rem",
    width: '95%',
  },
  wrongCard: {
    backgroundColor: "#EF0137",
    border: '2px solid #EF0137',
    margin: ".5rem",
    width: '95%',
  },
};

const omit = (obj, rmkey) => {
  const result = Object.keys(obj).filter((key) => key !== rmkey).reduce((newObj, key) => {
    newObj[key] = obj[key];
    return newObj;
  }, {});
  return result;
};

const _defaultOnFinish = () => { }

const DragToImage = ({
  id,
  cardList,
  textList,
  onFinish = _defaultOnFinish,
  theme = {},
}) => {

  const styles = { ...defaultTheme, ...theme };
  const [cards, setCards] = React.useState(cardList);
  const [choices, setChoices] = React.useState(textList);
  const [correctCount, setCorrectCount] = React.useState(0);
  const [showRetry, setShowRetry] = React.useState(false);
  const [disableDrag, setDisableDrag] = React.useState(false);
  const [isFinish, setIsFinish] = React.useState(false);

  const onDragEnd = ({ destination, draggableId }) => {
    if (destination === null) {
      return;
    }
    const textId = draggableId.split(":")[1];
    const [type, cardId] = destination.droppableId.split(":");
    const answerId = cards[cardId].answer;
    if (type !== 'card') {
      return
    }
    let newChoices = omit(choices, textId);
    const selectedCard = { ...cards[cardId] };
    if (!!selectedCard.value) {
      //just add the previous value back in it then
      newChoices = { ...newChoices, [selectedCard.value.id]: selectedCard.value.text }
    }
    selectedCard.value = { id: textId, text: choices[textId] }
    if (textId === answerId) {
      selectedCard.correct = true;
      setCorrectCount(correctCount + 1);
    } else {
      selectedCard.correct = false;
    }
    setChoices(newChoices);
    setCards(
      Object.fromEntries(
        Object.entries(cards).map(([id, card]) => {
          if (id === cardId) {
            return [id, selectedCard]
          } else {
            return [id, card]
          }
        })
      )
    ) 

  };
  const checkAnswer = () => {
    setCards(
    Object.fromEntries(
      Object.entries(cards).map(([id, card]) => {
        card.show = true;
        return [id, card];
      })
    )
    )
    setDisableDrag(true);
    if (correctCount === Object.keys(cards).length ) {
      setIsFinish(true);
    } else {
      setShowRetry(true);
    }
  }

  const retry = () => {
    setCards(
      Object.fromEntries(
        Object.entries(cards).map(([id, card]) => {
          card.show = false;
          card.correct = false;
          card.value = null;
          return [id, card];
        })
      )
      )
    setChoices(textList);
    setCorrectCount(0);
    setDisableDrag(false);
    setShowRetry(false);
  }

  const finish = () => {
    onFinish({
      id,
      score: correctCount,
      total: Object.keys(cards).length
    })
  }

  return (
    <DragDropContext onDragEnd={onDragEnd}>
      <Grid
        container
        direction={"row"}
        justifyContent={"space-around"}
        alignContent={"space-around"}
        sx={styles.root}
      >
        <Grid item xs={6} sx={styles.dropSite}>
          <Grid
            container
            direction="row"
            justifyContent="center"
            alignItems="center"
          >
            {Object.entries(cards)
              .map(([id, value]) => (
                <DroppableCard
                  key={"card:" + id}
                  id={"card:" + id}
                  card={value}
                  styles={styles}
                />
              ))}
          </Grid>
        </Grid>
        <Grid item xs={6} sx={styles.choiceSite}>
          <TextList
            choices={choices}
            id={"choices"}
            key={"choices"}
            styles={styles}
            isDraggable={disableDrag}
          />
        </Grid>
        {!isFinish && !showRetry && <Button style={{fontSize: '18px !important'}} className="bdo-button" onClick={checkAnswer}>Überprüfen</Button>}
        {showRetry && !isFinish && <Button style={{fontSize: '18px !important'}} className="bdo-button" onClick={retry}>Nochmal versuchen</Button>}
        {isFinish && <Button style={{fontSize: '18px !important'}} className="bdo-button" onClick={finish}>Weiter</Button>}
      </Grid>
    </DragDropContext>
  );
};

export default DragToImage;
